import { Api } from "../config/request";

export default {
  getFleetCoachDriverMappingList(body) {
    return Api.post(
      `/logistics-support/fleet-coach/fleet-coach-driver-mapping`,
      body
    );
  },
};
